import { ShieldCheck } from "lucide-react";
import Centered from "./Centered";

/**
 * Consent screen — explains the interview, conditionally shows the reward
 * notice (suppressed for programmatic-panel respondents), and emits a
 * compliance-mode-specific footer.
 */
export default function ScreenConsent({ campaign, tr, onContinue }) {
  return (
    <Centered>
      <div className="bg-white border border-[var(--rl-border)] p-10 max-w-lg w-full" data-testid="consent-screen">
        <ShieldCheck className="w-10 h-10 text-[var(--rl-brand)]" />
        <h1 className="font-display font-black text-3xl mt-5">You're invited to an interview.</h1>
        <p className="text-[var(--rl-text-secondary)] mt-4 leading-relaxed">A short conversational interview with adaptive follow-ups. Takes ~5 minutes.</p>
        <button onClick={onContinue} className="mt-8 w-full bg-[var(--rl-text)] text-white py-3 font-semibold hover:bg-[var(--rl-brand)] transition-colors" data-testid="consent-continue-btn">{tr("consent_start")}</button>
        <p className="text-xs text-[var(--rl-text-secondary)] mt-4 leading-relaxed" data-testid="consent-compliance">
          {(() => {
            const mode = campaign?.compliance_mode || "standard";
            if (mode === "gdpr") return tr("consent_compliance_gdpr");
            if (mode === "ccpa") return tr("consent_compliance_ccpa");
            if (mode === "hipaa") return tr("consent_compliance_hipaa");
            return tr("consent_compliance");
          })()}
        </p>
      </div>
    </Centered>
  );
}
